import { updateProject } from './updateProjectThunk';
export default updateProject;
